module.exports = __webpack_public_path__ + "static/media/result.61af8cf1.svg";